// deps
import React, { memo } from "react";

// internal-deps
import { Button } from "@swiggy-private/dls-web-core/dist/components/Button";
import { useEffectOnce } from "@swiggy-private/core-ui";

// test ids
import { GROUP_CART_ORDER_DATA_TEST_IDS } from "@swiggy-private/cart-test-ids";

// styles
import { AddMoreItemsTextContainer, Container } from "./AddMoreItems.style";

// constants
import { ADD_MORE_ITEMS, START_ADDING_ITEMS } from "@cart-ui/constants/GroupCart";

export interface IAddMoreItems {
    areItemsEmpty: boolean;
    impressionEvent?: VoidFunction;
}

const AddMoreItems = (props: IAddMoreItems) => {
    useEffectOnce(() => {
        props.impressionEvent?.();
    });

    return (
        <Button variant="secondary" data-testid={GROUP_CART_ORDER_DATA_TEST_IDS.ADD_MORE_ITEMS}>
            <Container>
                <AddMoreItemsTextContainer variant={"V2.body2.neutral.bold"} color="text_Button_Secondary">
                    {props.areItemsEmpty ? START_ADDING_ITEMS : ADD_MORE_ITEMS}
                </AddMoreItemsTextContainer>
            </Container>
        </Button>
    );
};

export default memo(AddMoreItems);
